module.exports = __webpack_public_path__ + "static/img/yhyz.6873a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/yhyz.png
// module id = z65W
// module chunks = 1